// `Blob.arrayBuffer` is missing in older Safari (and in some test envs), so
// fall back to FileReader.
export const readBlobBuffer = (blob: Blob): Promise<ArrayBuffer> => {
    if (typeof blob.arrayBuffer === 'function') return blob.arrayBuffer()

    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result as ArrayBuffer)
        reader.onerror = () => reject(reader.error)
        reader.readAsArrayBuffer(blob)
    })
}

// Files from the clipboard/drag-and-drop can be backed by a temp file on disk
// (e.g. Telegram's "Copy image"). The source app deletes or rewrites it soon
// after, and Chromium then aborts the upload with net::ERR_ACCESS_DENIED.
// Reading the bytes into memory right away makes the File independent of disk.
const snapshotFile = async (file: File): Promise<File> => {
    const buffer = await readBlobBuffer(file)
    return new File([buffer], file.name, {
        type: file.type,
        lastModified: file.lastModified,
    })
}

export const snapshotFiles = (files: File[]): Promise<File[]> => Promise.all(files.map(snapshotFile))
